import React, { useState } from 'react'
import useEmblaCarousel from 'embla-carousel-react'
import Autoplay from 'embla-carousel-autoplay'
import style from './index.module.less'
import { useDotButton, DotButton } from "../DotButton"
import {
  NextButton,
  PrevButton,
  usePrevNextButtons
} from '../ArrowButtons'
import { useAutoplay } from '../Autoplay'

const Carousel = (props) => {
  const { 
    slides, 
    options, 
    CustomContentComponent, 
    customControlsSty, 
    customDotsColorSty, 
    customDotSelectedSty,
    showArrowsBtn = false
  } = props
  const [emblaRef, emblaApi] = useEmblaCarousel(options, [Autoplay({ delay: 7000 })])
  // const [emblaRef, emblaApi] = useEmblaCarousel(options) 
  const { selectedIndex, scrollSnaps, onDotButtonClick } = useDotButton(emblaApi)
  const {
    prevBtnDisabled,
    nextBtnDisabled,
    onPrevButtonClick,
    onNextButtonClick
  } = usePrevNextButtons(emblaApi)
  const { onAutoplayButtonClick } = useAutoplay(emblaApi)

  const [hoverShowArrow, setHoverShowArrow] = useState(false)
    
  return (
    <section className={style.carousel}>
      <div className={style.carouselViewport}
        ref={emblaRef}
        onMouseEnter={() => setHoverShowArrow(true)}
        onMouseLeave={() => setHoverShowArrow(false)}
      >
        <div className={style.carouselContainer}>
          {slides.map((carItem, index) => (
            <CustomContentComponent carItem={carItem} key={`car-${carItem.title}`} index={index} />
          ))}

        </div>
      </div>

      {showArrowsBtn && <div
        className={style.carouselArrows}
        style={{opacity: hoverShowArrow ? 1 : 0}}
        onMouseEnter={() => setHoverShowArrow(true)}
      >
        <PrevButton
          onClick={() => onAutoplayButtonClick(onPrevButtonClick)}
          disabled={prevBtnDisabled}
        />
        <NextButton
          onClick={() => onAutoplayButtonClick(onNextButtonClick)}
          disabled={nextBtnDisabled}
        />
      </div>}

      <div className={`${style.carouselControls} ${customControlsSty || ''}`}>
        <div className={style.carouselDots}>
          {scrollSnaps.map((item, index) => (
            <DotButton
              key={`dot-${item}-${index}`}
              onClick={() => onDotButtonClick(index)}
              className={`
                ${style.carouselDot } 
                ${customDotsColorSty || style.dotsColorDefault}
                ${index === selectedIndex ? (customDotSelectedSty || style.carouselDotSelected) : ''}
              `}
            />
          ))}
        </div>
      </div>

    </section>
  )
}

export default Carousel
